import { Injectable } from "@angular/core";
import { FilterService } from "./filter.service";
import { SessionService } from "./session.service";

@Injectable({
  providedIn: "root",
})
export class UserActivityService {

  hierarchicalGridState:any = [];

  userStateData:any = {
    "username" : "",
    "selectedFilters" : {},
    "pageTab":0,
    "selectedType": ''
  }

  userStateForTimeCycleFilter:any = {
    "selectedFilters" : {},
  }
  
  userStateSingleDateFilter:any = {
    "selectedFilters" : {},
  }
  
  userStateForTimeCycleFilterSingle:any = {
    "selectedFilters" : {},
  }
  userStateForKPI:any = {
    "selectedFilters" : {},
  }

  constructor(
    private sessionService:SessionService,
    private filterService:FilterService  
  ) {
  }
  private key = 'userState';
  private userStateSingleDate = 'userStateSingleDate';
  private userStateTime = 'userStateTime';
  private userStateTimeSingle = 'userStateTimeSingle';
  private userStateKpiSingle = 'userStateKpiSingle';

  getData(): any {
    const data:any = sessionStorage.getItem(this.key);
    return JSON.parse(data) || this.userStateData;
  }

  getDataTimeCycle(): any {
    const data:any = sessionStorage.getItem(this.userStateTime);
    if(!data) {
      return {"selectedFilters" : {}}
    }
    return JSON.parse(data);
  }
  
  getDataTimeCycleSingle(): any {
    const data:any = sessionStorage.getItem(this.userStateTimeSingle);
    return JSON.parse(data) || this.userStateForTimeCycleFilterSingle;
  }
  
  getDataKpiSingle(): any {
    const data:any = sessionStorage.getItem(this.userStateKpiSingle);
    return JSON.parse(data) || this.userStateForKPI;
  }

  // Set Date for User filter
  setData(data: any): void {
    this.userStateData = this.getData()
    let userName = this.sessionService.getUser()
    this.userStateData['username'] = userName.username

    // Object into Array of Object
    let updatesObj:any = Object.entries(data).map(([key, value]) => ({ key, value }));

    for(let i = 0; i <  updatesObj.length; i++) {
      if(updatesObj[i].key == "selectedFilters") {
        let Obj:any = Object.entries(updatesObj[i].value).map(([key, value]) => ({ key, value }));
        Obj.forEach((res:any)=> {
          this.userStateData[updatesObj[i].key][res.key] = res.value
        })
      } else {
        this.userStateData[updatesObj[i].key] = updatesObj[i].value
      }
    }

    const serializedData:any = JSON.stringify(this.userStateData);
    sessionStorage.setItem(this.key, serializedData);
  }

  // time cycle based on filter 
  setDataTimeCycle(data: any): void {
    this.userStateForTimeCycleFilter = this.getDataTimeCycle()

    // Object into Array of Object
    let updatesObj:any = Object.entries(data).map(([key, value]) => ({ key, value }));

    for(let i = 0; i <  updatesObj.length; i++) {
      if(updatesObj[i].key == "selectedFilters") {
        let Obj:any = Object.entries(updatesObj[i].value).map(([key, value]) => ({ key, value }));
        Obj.forEach((res:any)=> {
          this.userStateForTimeCycleFilter[updatesObj[i].key][res.key] = res.value
        })
      } else {
        this.userStateForTimeCycleFilter[updatesObj[i].key] = updatesObj[i].value
      }
    }
    

    const serializedData:any = JSON.stringify(this.userStateForTimeCycleFilter);
    sessionStorage.setItem(this.userStateTime, serializedData);
  }

  // time cycle based on filter 
  setDataTimeCycleSingle(data: any): void {
    this.userStateForTimeCycleFilterSingle = this.getDataTimeCycleSingle()

    // Object into Array of Object
    let updatesObj:any = Object.entries(data).map(([key, value]) => ({ key, value }));

    for(let i = 0; i <  updatesObj.length; i++) {
      if(updatesObj[i].key == "selectedFilters") {
        let Obj:any = Object.entries(updatesObj[i].value).map(([key, value]) => ({ key, value }));
        Obj.forEach((res:any)=> {
          this.userStateForTimeCycleFilterSingle[updatesObj[i].key][res.key] = res.value
        })
      } else {
        this.userStateForTimeCycleFilterSingle[updatesObj[i].key] = updatesObj[i].value
      }
    }
    

    const serializedData:any = JSON.stringify(this.userStateForTimeCycleFilterSingle);
    sessionStorage.setItem(this.userStateTimeSingle, serializedData);
  }


  // KPI Single based on filter 
  setDataKpiSingle(data: any): void {
    this.userStateForKPI = this.getDataKpiSingle();

    // Object into Array of Object
    let updatesObj:any = Object.entries(data).map(([key, value]) => ({ key, value }));

    for(let i = 0; i <  updatesObj.length; i++) {
      if(updatesObj[i].key == "selectedFilters") {
        let Obj:any = Object.entries(updatesObj[i].value).map(([key, value]) => ({ key, value }));
        Obj.forEach((res:any)=> {
          this.userStateForKPI[updatesObj[i].key][res.key] = res.value
        })
      } else {
        this.userStateForKPI[updatesObj[i].key] = updatesObj[i].value
      }
    }
    

    const serializedData:any = JSON.stringify(this.userStateForKPI);
    sessionStorage.setItem(this.userStateKpiSingle, serializedData);
  }

  setUserStateSingleDate(data: any): void {
    const serializedData:any = JSON.stringify(data);
    sessionStorage.setItem(this.userStateSingleDate, serializedData);
  }
  
   
  getUserStateSingleDate(): any {
    const data:any = sessionStorage.getItem(this.userStateSingleDate);
    if(!data) {
      return
    }
    return JSON.parse(data);
  }

  // ---- static dashboards' dynamic filters ---------------------------------
  //
  // DPM-Static and DEM-Static have no filter widget, so nothing writes their
  // selection here for them the way multi-select.component does for a dynamic
  // page. They resolve their own dynamic filters (Brand, and anything added
  // beside it in DPM_DYNAMIC_FILTERS) and publish the result themselves — see
  // each screen's seedFilterState(), which already runs on every load and so
  // after every filter change.
  //
  // A field of its own rather than entries in `selectedFilters`, for two
  // reasons. That map is keyed by widget field name and shared by every page in
  // the session, so a static screen writing `brand_name` into it would be
  // indistinguishable from a dynamic page's filter of the same name — and
  // setData() MERGES it key by key and never removes, so there would be no way
  // to clear only the static screens' half of it. A plain field is overwritten
  // wholesale by setData(), which is what makes clearStaticFilters() a one-liner.
  //
  // Keyed by dashboard inside that field, so DPM-Static and DEM-Static keep
  // their own selections instead of the second one visited overwriting the
  // first.
  private staticFiltersField = "staticFilters";

  /** One static dashboard's saved dynamic-filter selection, or {} when it has
   *  none — a fresh session, or a module/dashboard click having cleared it. */
  getStaticFilters(dashboardKey: any): any {
    try {
      const all = this.getData()?.[this.staticFiltersField];
      return (all && all[String(dashboardKey ?? "")]) || {};
    } catch {
      return {};
    }
  }

  /**
   * Remember what a static dashboard's dynamic filters are currently on.
   *
   * `filters` is keyed by the filter's own key (brand_name), each entry holding
   * both the request values and their labels — the same pair a bookmark carries,
   * and for the same reason: the keys are what the next visit re-selects by, and
   * the labels are the fallback for when the API has since re-issued them.
   */
  setStaticFilters(dashboardKey: any, filters: any): void {
    try {
      const all = { ...(this.getData()?.[this.staticFiltersField] || {}) };
      all[String(dashboardKey ?? "")] = filters;
      this.setData({ [this.staticFiltersField]: all });
    } catch {
      /* storage unavailable, or no user on the session yet — the screens fall
         back to their defaults, which is the pre-existing behaviour */
    }
  }

  /**
   * Forget every static dashboard's dynamic-filter selection.
   *
   * Called where the portal already draws the line for its own user state: a
   * module click (DashboardService.userMenuModuleHandle) and a dashboard card
   * click (DashboardComponent.openPage, static cards included). Both are an
   * explicit "start here", and a screen that came up on a week-old brand there
   * reads as broken rather than as remembered.
   */
  clearStaticFilters(): void {
    try {
      this.setData({ [this.staticFiltersField]: {} });
    } catch {
      /* as above */
    }
  }

  clearTimeCycleFilter() {
    // reset the Time Cycle filter to default when we navigate to new page
    this.setData({ "selectedType": ""});
    sessionStorage.removeItem('singleTimeCycleQuarter');
    // single date selection
    sessionStorage.removeItem('userStateSingleDate');
    this.filterService.resetForBrandBased();
    this.filterService.resetForBrandBasedSingle();
    this.filterService.report_type = "";
    this.filterService.time_cycle = "";
    /////////////////////////////////////
  }
}
